import { searchActions } from '../../../config';
import { TThunk } from '../../../';

interface ISearchResultsParams {
  q: string;
  per_page: number;
  scopes?: string[];
  page: number;
  include_other_scopes?: 1;
}

let cancelAction: AbortController | null = null;

export const searchResultsByValue =
  ({
    skipCountRequest,
    searchValue,
    loadMore,
    scopes,
    includeOtherScopes,
    dropdownMode,
  }: {
    skipCountRequest: boolean;
    searchValue?: string;
    loadMore?: boolean;
    scopes?: string[];
    includeOtherScopes?: 1;
    dropdownMode?: boolean;
  }): TThunk =>
  async (dispatch, getState, api) => {
    const {
      search: { pagination, value, resultList, selectedSearchScopes },
    } = getState();

    if (cancelAction) {
      cancelAction.abort();
    }

    const valueToSend = searchValue || value;
    let { currentPage } = pagination;

    const controller = new AbortController();
    const { signal } = controller;

    cancelAction = controller;

    dispatch(searchActions.setValue(valueToSend));
    dispatch(searchActions.setLoading(true));

    try {
      if (!skipCountRequest) {
        currentPage = 1;
        dispatch(searchActions.setPagination({ currentPage: 1 }));

        const data = await api.search.getSearchResultsCount(valueToSend, { signal });
        dispatch(searchActions.setResultCount(data));
      }

      const paramsToSend: ISearchResultsParams = {
        q: valueToSend,
        per_page: pagination.perPage,
        scopes: scopes || selectedSearchScopes,
        page: currentPage,
      };

      if (includeOtherScopes) {
        paramsToSend.include_other_scopes = includeOtherScopes;
      }

      if (loadMore) {
        const remainTickets =
          pagination.total - pagination.currentPage * Number(pagination.perPage);

        if (remainTickets > 0) {
          paramsToSend.page = currentPage + 1;
        } else {
          dispatch(searchActions.setLoading(false));
          return;
        }
      }

      const {
        data,
        meta: { total, page, perPage },
      } = await api.search.searchResults(paramsToSend, { signal });

      cancelAction = null;

      dispatch(searchActions.setPagination({ currentPage: page, perPage, total }));

      if (dropdownMode) {
        dispatch(searchActions.setDropdownResultList(data));
      } else {
        dispatch(
          searchActions.setResultList(paramsToSend.page === 1 ? data : [...resultList, ...data]),
        );
      }

      dispatch(searchActions.setLoading(false));
    } catch (error: any) {
      if (error.name === 'CanceledError') return;

      dispatch(searchActions.setLoading(false));
    }
  };
